
var ProgressService = function() {
  if (ProgressService.prototype._singleton){
    return ProgressService.prototype._singleton;
  }
  ProgressService.prototype._singleton = this;
  var progress = new EF.Models.ProgressTracker({module_key: 'course'}, {});

  this.saveLocalActivityProgress = function (activityProgress, moduleKey) {
    if (moduleKey) {
      var mod = EF.modules.find({ key: moduleKey });
      mod.progress.saveLocalActivityProgress(activityProgress);
    } else {
      progress.saveLocalActivityProgress(activityProgress);
    }
    return EF.activityProgresses.fetch();
  };
  this.getLocalActivityProgresses = function () {
    var progresses = EF.modules.reduce((memo, mod) => {
      var prog = mod.progress.getLocalActivityProgress();
      if (prog) {
        memo = memo.concat(prog);
      }
      return memo;
    }, []);
    var courseProg = progress.getLocalActivityProgress();
    if (courseProg) {
      progresses = progresses.concat(progress.getLocalActivityProgress());
    }
    return progresses;
  };
  this.removeLocalActivityProgress = function(slug, moduleKey) {
    if (moduleKey){
      var mod = EF.modules.find({ key: moduleKey });
      mod.progress.removeLocalActivityProgress(slug);
    } else {
      progress.removeLocalActivityProgress(slug);
    }
    return EF.activityProgresses.fetch();
  };
};

module.exports = new ProgressService();